import {
  CataloguePayloadModel,
  CurrentCatalogueErrorsModel,
  CurrentStoreListingErrorModel,
  StoreListingPayloadModel,
} from 'src/models';

class InitialState {
  constructor() {
    this.uiState = new UIState();

    this.subjectManageState = new SubjectManageState();
    this.subjectReview = new SubjectReviewState();
    this.publisherState = new PublisherStateModel();
  }
}

/* *****************************  [TRANSCODING MANAGER]  ************************** */

export class TranscodingManagerStoreModel {
  constructor() {
    this.tobeTranscodedJobs = [];
    this.toBeReTranscodedJobs = [];
    this.cancelledJobs = [];
    this.erroredJobs = [];
    this.submittedJobs = [];
    this.runningJobs = [];
    this.finishedJobs = [];
    this.isTranscodingSuccess = false;
  }
}

/* *****************************  [PUBLISHER]  ************************** */

export class PublisherStateModel {
  constructor() {
    this.catalogueManager = new CatalogueManagerStateModel();
    this.storeManager = new StoreManagerStateModel();
    this.otsManager = new OtsManagerStateModel();
  }
}

export class CatalogueManagerStateModel {
  constructor() {
    this.catalogueList = []; // List of catalogue and storeListing
    this.batches = [];
    this.curentCatalogueSubjectList = [];
    this.catalogueSubjectList = [];

    // catalogue details from backend
    this.currentCatalogueInfo = '';
    // this is the payload send to the backend on save
    this.currentCatalogueInfoPayload = new CataloguePayloadModel();
    // This is used to display error in step indicator
    this.currentCatalogueErrors = new CurrentCatalogueErrorsModel();
    this.isSubmit = false;
  }
}

export class StoreManagerStateModel {
  constructor() {
    this.categoryList = []; // list of caegory and subcategory
    this.storeList = []; // list of store listing
    this.selectedStoreList = []; // list of selected store listing in selected subcategory
    this.selectedCategory = {}; // selected category in the category page
    this.selectedSubCategory = {}; // selected sub category in the category page
    this.selectedCategoryIndex = '';
    this.selectedSubCategoryIndex = '';

    // catalogue details from backend
    this.currentStoreListing = '';
    // this is the payload send to the backend on save
    this.currentStoreListingPayload = new StoreListingPayloadModel();
    // This is used to display error in step indicator
    this.currentStoreStepsError = new CurrentStoreListingErrorModel();
    this.isSubmit = false;
  }
}

export class OtsManagerStateModel {
  constructor() {
    this.otsCatalogueList = [];
    this.subscriptionsList = [];
    this.backupSubscriptionList = [];
  }
}

/* ********************************************************************** */

class SubjectManageState {
  constructor() {
    this.subjects = [];
    this.finishedSubjects = [];
    this.subjectTypeList = {};
    this.users = [];
    this.currentSubjectId = '';
    this.currentUnitId = '';
    this.subjectsWithUnits = [];
    this.subjectsUnitPayload = [];
    this.unitsTopicPaylaod = [];
    this.subjectsVideos = [];
    this.subjectVideoUrls = [];
    this.assignees = [];

    this.lastApiTimeStamp = ''; // Since, i am caching the api response, i need to know when to refresh.
  }
}

class CouponManagementState {
  constructor() {
    this.coupons = [];
    this.catalogues = [];
  }
}

class SubjectReviewState {
  constructor() {
    this.finishedSubjects = [];
  }
}

class UserManagementState {
  constructor() {
    this.users = [];
    this.roles = [];
    this.courses = [];
  }
}

class LoginManagementState {
  constructor() {
    this.isOTPcreated = false;
    this.loginSuccess = false;
  }
}

class UISuccessState {
  constructor() {
    this.isSuccess = false;
    this.showBanner = false;
    this.message = '';
    this.bannerAutoHideDuration = 6000;
    this.response = '';
    this.title = '';
    this.isAuthTokenValid = true;
  }
}

class UIErrorState {
  constructor() {
    this.hasError = false;
    this.showBanner = false;
    this.message = '';
    this.bannerAutoHideDuration = 6000;
    this.response = '';
    this.title = '';
    this.isAuthTokenValid = true;
  }
}

class UIState {
  constructor() {
    this.error = new UIErrorState();
    this.success = new UISuccessState();
    this.currentState = ''; // map this to "error/success" to dynamically access the curent state
    this.showSpinner = false;
    this.apiInProgress = false;
    this.showSuccessBanner = false;
    this.uiRouteState = [];
  }
}

class FileExplorerState {
  constructor() {
    this.files = [];
    this.currentState = {
      isSubjectsFolder: true,
      viewType: 'Subjects',
      subject: '',
      subjectId: '',
      unit: '',
      unitId: '',
      topic: '',
      topicId: '',
    };
    this.rawEachSubject = {};
    this.currentList = [];
    this.allSubjects = [];
    this.liveClassRecordings = [];
  }
}

class LegalPageState {
  constructor() {
    this.allTncList = [];
  }
}

class DeliveryState {
  constructor() {
    this.tableInfoList = [];
    // for filters
    this.catalogues = [];
  }
}

class StudentUpdatesState {
  constructor() {
    this.updates = [];
  }
}

class StudentDetailsState {
  constructor() {
    this.studentDetails = [];
    this.subscriptionsList = [];
    this.invoicesList = [];
    this.emailverified = false;
  }
}

class LiveClassData {
  constructor() {
    this.liveClasses = {
      upcoming: {},
      today: {},
      completed: {},
    };
    this.subjects = [];
    this.chapters = [];
    this.teachers = [];
    this.batches = [];
    this.newChapter = {};
    this.newSubject = {};
    this.zoomAccounts = [];
  }
}
class BatchDetailsState {
  constructor() {
    this.batchList = [];
    this.studentsList = [];
    this.branchList = [];
    this.programList = [];
    this.createUpdateOrCloseBatchSuccess = false;
    this.createGroupSuccess = false;
    this.uploadStudentsSuccess = false;
    this.batchDetails = {};
    this.groupList = [];
  }
}

class AttendanceDetailsState {
  constructor() {
    this.classroomAttendanceData = [];
    this.studentsAttendanceData = [];
    this.studentsDetails = {};
  }
}

export {
  InitialState,
  SubjectManageState,
  SubjectReviewState,
  UserManagementState,
  LoginManagementState,
  UIErrorState,
  UISuccessState,
  UIState,
  FileExplorerState,
  CouponManagementState,
  LegalPageState,
  DeliveryState,
  StudentUpdatesState,
  StudentDetailsState,
  LiveClassData,
  BatchDetailsState,
  AttendanceDetailsState,
};
